import React, { useEffect, useState, useCallback } from 'react';
import { Document, Page, PDFViewer, View, Text, pdf } from '@react-pdf/renderer';

import { pageStyle } from './styleBonafidePdf';
import BonafideHeader from './bonafideHeader';
import BonafideContent from './bonafideContent';
import BonafideNotice from './bonafideNotice';
import BonafideFooter from './bonafideFooter';

const BonafidePdfAndroid = (props) => {
    const [pdfDetails, setPdfDetails] = useState({
        certificateName: "Bonafide Certificate",
        gender: "",
        parentName: "",
        enrollmentNo: "",
        cls: "",
        academicYear: "",
        dob: "",
        studentName: "",
        schoolName: "",
        classTeacherSign: "",
        schoolLogo: "",
        principalSign: "",
        studentNotes: "",
        printDt: "",
    });
    const [documentOpeningCalled, setDocumentLoadingCalled] = useState(false);

    // Update details when props change
    useEffect(() => {
        if (props.pdfDtls && !documentOpeningCalled) {
            setDetails(props.schoolLogo, props.principalSign, props.pdfDtls);
        }
    }, [props.pdfDtls, props.schoolLogo, props.principalSign, documentOpeningCalled]);

    // Function to set details
    const setDetails = useCallback((pSchoolLogo, pPrincipalSign, pdfDtls) => {
        setPdfDetails({
            certificateName: "Bonafide Certificate",
            gender: pdfDtls.gender,
            parentName: pdfDtls.father,
            enrollmentNo: pdfDtls.enrollmentNo,
            cls: pdfDtls.cls,
            academicYear: pdfDtls.acdYr,
            dob: pdfDtls.dob,
            studentName: pdfDtls.student,
            schoolName: pdfDtls.school,
            classTeacherSign: pdfDtls.pathClassTeacherSign,
            schoolLogo: pSchoolLogo,
            principalSign: pPrincipalSign,
            studentNotes: pdfDtls.remarksPrint,
            printDt: pdfDtls.printDt,
        });

        if (!documentOpeningCalled) {
            openDocument();
        }
    }, [documentOpeningCalled]);

    // Function to open the document
    const openDocument = useCallback(async () => {
        setDocumentLoadingCalled(true);

        const pdfDocument = await generateDocument();

        try {
            // Generate the PDF Blob
            const blob = await pdf(pdfDocument).toBlob();

            // Check the file size
            const fileSizeInMB = blob.size / (1024 * 1024); // Size in MB
            const fileSizeThreshold = 10; // Threshold in MB

            if (fileSizeInMB > fileSizeThreshold) {
                // If file is too large, suggest downloading
                window.alert(`The file size is too large (${fileSizeInMB.toFixed(2)} MB). It may be slow to open. Downloading instead...`);

                // Force download
                const downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = `${pdfDetails.studentName}_BonafideCertificate.pdf`;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            } else {
                // Attempt to open the PDF in a new tab
                const fileURL = URL.createObjectURL(blob);
                const newTab = window.open(fileURL, '_blank');

                // Check if the tab was successfully opened
                if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                    window.alert('Popup blocked. Downloading file instead...');
                    const downloadLink = document.createElement('a');
                    downloadLink.href = fileURL;
                    downloadLink.download = `${pdfDetails.studentName}_BonafideCertificate.pdf`;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
            }
        } catch (error) {
            console.error('Error opening or downloading PDF:', error);
        }
    }, [pdfDetails]);

    // Function to generate the document
    const generateDocument = useCallback(() => {
        return (
            <Document>
                <Page orientation="landscape" size="A4" style={pageStyle.page}>
                    <View style={pageStyle.page_border}>
                        <View style={pageStyle.header_section}>
                            <BonafideHeader
                                schoolLogo={pdfDetails.schoolLogo}
                                schoolName={pdfDetails.schoolName}
                            />
                        </View>
                        <View style={[pageStyle.certificate_content_section]}>
                            <BonafideContent
                                printDt={pdfDetails.printDt}
                                certificateName={pdfDetails.certificateName}
                                gender={pdfDetails.gender}
                                studentName={pdfDetails.studentName}
                                parentName={pdfDetails.parentName}
                                enrollmentNo={pdfDetails.enrollmentNo}
                                cls={pdfDetails.cls}
                                year={pdfDetails.academicYear}
                                dob={pdfDetails.dob}
                                schoolName={pdfDetails.schoolName}
                                notes={pdfDetails.studentNotes}
                            />
                        </View>
                        <View style={pageStyle.footer_section}>
                            <BonafideFooter
                                principalSign={pdfDetails.principalSign}
                                teacherSign={pdfDetails.classTeacherSign}
                            />
                        </View>
                    </View>
                </Page>
            </Document>
        );
    }, [pdfDetails]);

    return <div />;
};

export default BonafidePdfAndroid;
